import { NgIf, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { AgrNumberDirective } from '@next/core-lib/form';
import { TranslatePipe } from '@next/core-lib/i18n';

import { ObservationsRegistration } from '../../models/performance.model';

@Component({
  selector: 'app-observations-registration-form',
  templateUrl: './observations-registration-form.component.html',
  styleUrls: ['./observations-registration-form.component.scss'],
  imports: [
    ReactiveFormsModule,
    NgIf,
    MatFormField,
    MatLabel,
    MatInput,
    AgrNumberDirective,
    MatButton,
    MatTooltip,
    MatSelect,
    MatOption,
    NgFor,
    MatSuffix,
    TranslatePipe,
  ],
})
export class ObservationsRegistrationFormComponent {
  @Input() formGroup: FormGroup;
  @Input() showFields: string[];
  @Input() chickAgeInDays: number;
  @Output() copyValuesCalledEvent = new EventEmitter<ObservationsRegistration>();

  public feedCodes: string[] = [
    'Pluvita Neo 1 VITA',
    'Pluvita Neo 2 VITA',
    'Pluvita Neo 2 + 3 VITA',
    'Pluvita Neo 3 VITA',
    'Pluvita Neo 3 + 4 VITA',
    'Pluvita Neo 4 VITA',
    'Pluvita Neo 2 VITA + 3 CALMA',
    'Pluvita Neo 3 CALMA',
    'Pluvita Neo 3 + 4 CALMA',
    'Pluvita Neo 4 CALMA',
  ];

  showField(fieldToShow: string): boolean {
    return !!this.showFields && this.showFields.findIndex((field) => field === fieldToShow) > -1;
  }

  copyValuesToOtherDaysOfWeek() {
    this.copyValuesCalledEvent.emit({
      barnId: 0,
      cycleId: 0,
      day: 0,
      sectionId: 0,
      feedName: this.showField('feedName') ? this.formGroup.controls.feedName.value : undefined,
      feedIntakeInGramsPerAnimal: this.showField('feedIntakeInGramsPerAnimal')
        ? this.formGroup.controls.feedIntakeInGramsPerAnimal.value
        : undefined,
      waterIntakeInLitersTotal: this.showField('waterIntakeInLitersTotal')
        ? this.formGroup.controls.waterIntakeInLitersTotal.value
        : undefined,
      numberOfMinutesLight: this.showField('numberOfMinutesLight')
        ? this.formGroup.controls.numberOfMinutesLight.value
        : undefined,
      lightIntensityInLux: this.showField('lightIntensityInLux')
        ? this.formGroup.controls.lightIntensityInLux.value
        : undefined,
    });
  }
}
